import React from 'react';

import {I18n} from '@aws-amplify/core';

import {useNavigate} from 'react-router-dom';

import {Box} from '@mantine/core';

import {ButtonGhostIcon, IconHome16} from 'pac-ux-components';

export const PageNotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <Box>
            <Box variant="h1">404 - {I18n.get('Page Not Found')}</Box>
            <div
                style={{
                    marginTop: '2em',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                }}
            >
                <ButtonGhostIcon
                    type="button"
                    icon={<IconHome16/>}
                    onClick={(event) => {
                        event.preventDefault();
                        navigate('/');
                    }}
                    tabIndex={3}
                >
                    {I18n.get('Home')}
                </ButtonGhostIcon>
            </div>
        </Box>
    );
};
